module.exports = __webpack_public_path__ + "static/media/C43.600fa5b1.png";